import script from "./Error.vue?vue&type=script&setup=true&lang=ts"
export * from "./Error.vue?vue&type=script&setup=true&lang=ts"

import "./Error.vue?vue&type=style&index=0&id=b23f875e&scoped=true&lang=less"

import exportComponent from "/opt/teams-app/node_modules/.pnpm/vue-loader@17.0.0_webpack@5.74.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b23f875e"]])

export default __exports__